import type { SearchRequest, SearchResponse } from '../../contracts/src/search.js';

export function searchCacheKey(request: SearchRequest): string {
  const filters = Object.entries(request.filters ?? {}).sort(([a], [b]) => a.localeCompare(b)).map(([key, value]) =>
    [key, Array.isArray(value) ? [...value].map(item => key === 'ids' || key === 'clusterIds' ? String(item) : String(item).trim().toLowerCase()).sort() : value]);
  return JSON.stringify([request.vector, request.k, request.efSearch, request.exact, request.queryKind,
    request.queryText?.trim().toLowerCase(), filters]);
}

export class SearchCache {
  readonly #entries = new Map<string, SearchResponse>();
  constructor(readonly capacity = 24) {}
  get(key: string): SearchResponse | undefined {
    const value = this.#entries.get(key);
    if (value) { this.#entries.delete(key); this.#entries.set(key, value); }
    return value;
  }
  set(key: string, value: SearchResponse): void {
    this.#entries.delete(key); this.#entries.set(key, value);
    while (this.#entries.size > this.capacity) this.#entries.delete(this.#entries.keys().next().value!);
  }
  clear(): void { this.#entries.clear(); }
}
